<template>
  <div class="xh-filter-layout">
    <div class="title-container" v-if="title">
      <div class="title-left">
        <div class="icon">
          <slot name="icon">
            <div class="default-icon"></div>
          </slot>
        </div>
        <div class="title">{{ title }}</div>
      </div>
      <div class="title-right">
        <slot name="title-right"></slot>
      </div>
    </div>
    <div
      class="content-container"
      :class="{
        'ext-filter-content': extraFilter,
        'content-container-notitle': !title,
      }"
    >
      <div
        class="filter-container"
        ref="mainFilter"
        v-if="
          (leftModel === 'bottom' && $slots.filter) ||
          (!leftVisible && $slots.filter)
        "
      >
        <div class="filter-content">
          <slot name="filter"></slot>
        </div>
        <el-tooltip content="更多筛选条件" placement="top">
          <i
            class="el-icon-arrow-down ext-filter-btn"
            v-if="extraFilter"
            :class="{ 'ext-filter-btn-up': this.extFilterVisible }"
            @click="extFilterClick"
          ></i>
        </el-tooltip>
      </div>
      <div class="show-container">
        <div
          class="left"
          v-if="leftVisible"
          :class="{ 'left-hide': !left.visible }"
        >
          <div
            class="left-content"
            :class="{
              'left-hide': !left.visible,
              'left-content-hide': !left.visible,
            }"
          >
            <slot name="left"></slot>
          </div>
          <div class="left-btn" @click="toggleLeft">
            <i
              :class="{
                'el-icon-arrow-right': !left.visible,
                'el-icon-arrow-left': left.visible,
              }"
            ></i>
          </div>
        </div>
        <div
          class="main-content"
          :class="{
            'main-content-leftmodel': leftModel === 'top' && leftVisible,
          }"
        >
          <div
            class="filter-container"
            :class="{ 'filter-right': leftModel === 'top' && leftVisible }"
            ref="mainFilter"
            v-if="
              leftModel === 'top' &&
              $slots.filter &&
              leftVisible &&
              $slots.filter
            "
          >
            <div class="filter-content">
              <slot name="filter"></slot>
            </div>
            <el-tooltip content="更多筛选条件" placement="top">
              <i
                class="el-icon-arrow-down ext-filter-btn"
                v-if="extraFilter"
                :class="{ 'ext-filter-btn-up': this.extFilterVisible }"
                @click="extFilterClick"
              ></i>
            </el-tooltip>
          </div>
          <div
            class="wh100"
            :class="{ 'main-content-box': leftModel === 'top' && leftVisible }"
          >
            <slot name="content"> </slot>
          </div>
        </div>
      </div>
      <transition name="el-zoom-in-top" v-if="extraFilter">
        <div
          ref="extFilter"
          class="ext-filter"
          v-if="extraFilter"
          v-show="extFilterVisible"
        >
          <slot name="extFilter"></slot>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    extraFilter: {
      type: Boolean,
      default: false,
    },
    //标题，不传值时默认不显示标题
    title: {
      type: String,
      default: "",
    },
    leftVisible: {
      type: Boolean,
      default: false,
    },
    //左侧的模式，只有leftVisible为true时，leftModel才有效
    leftModel: {
      type: String,
      default: "top",
    },
  },
  data() {
    return {
      extFilterVisible: false,
      left: {
        visible: true,
      },
    };
  },
  mounted() {},
  methods: {
    toggleLeft() {
      this.left.visible = !this.left.visible;
    },
    extFilterClick() {
      let mainFilterHeight = Number(
        window
          .getComputedStyle(this.$refs.mainFilter)
          .getPropertyValue("height")
          .replace("px", "")
      );
      this.$refs.extFilter.style.top = mainFilterHeight + "px";
      this.extFilterVisible = !this.extFilterVisible;
    },
  },
};
</script>
<style lang="less" scoped>
.xh-filter-layout {
  width: 100%;
  height: 100%;
}

.title-container {
  width: 100%;
  height: 36px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border-bottom: 1px solid #e3e3e3;
  justify-content: space-between;
  .title-left,
  .title-right {
    height: 100%;
    display: flex;
    align-items: center;
  }
  .icon {
    margin-right: 8px;
    height: 100%;
    display: flex;
    align-items: center;
    .default-icon {
      height: 18px;
      width: 4px;
      background: @basecolor;
      border-radius: 50px;
    }
  }
  .title {
    font-size: 16px;
  }
}
.content-container-notitle {
  height: 100% !important;
}
.content-container {
  width: 100%;
  display: flex;
  height: calc(100% - 36px);
  flex-direction: column;
  box-sizing: border-box;
  .filter-container {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 8px;
    box-sizing: border-box;
    z-index: 5;
    // border-bottom: 1px solid #eee;
  }

  .show-container {
    width: 100%;
    padding: 8px;
    height: 0;
    flex: 1;
    flex-basis: auto;
    background: #f1f1f1;
    box-sizing: border-box;
    display: flex;
    overflow: hidden;
  }
}

.ext-filter-content {
  position: relative;
}
.ext-filter {
  position: absolute;
  width: 100%;
  z-index: 4;
  box-sizing: border-box;
  box-shadow: 0 5px 4px -4px rgba(0, 0, 0, 0.1);
  padding: 8px;
  border-bottom: 1px solid #eee;
  border-radius: 0 0 4px 4px;
  left: 0;
  background: #fff;
}
.ext-filter-btn {
  margin-left: 8px;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.3s;
  outline: medium;
  margin-bottom: 8px;
}
.ext-filter-btn-up {
  transform: rotate(180deg);
}
.filter-content {
  width: 100%;
  /deep/.el-form-item {
    margin-bottom: 0px !important;
  }
}

.main-content {
  width: 0;
  height: 100%;
  flex: 1;
  background: #fff;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #eee;
  padding: 8px;
  transition: all 0.3s ease;
  .main-content-box {
    width: 100%;
    height: 0;
    flex: 1;
  }
  .filter-right {
    padding: 0;
    padding-bottom: 8px;
  }
}
.main-content-leftmodel {
  flex: 1;
  width: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.left {
  border-radius: 4px;
  border: 1px solid #eee;
  width: 21%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  margin-left: 0;
  margin-right: 8px;
  background: #fff;
  transition: width 0.3s ease;
}
.left-hide {
  width: 0;
  margin-left: -8px;
  border: 0;
}
.left-content {
  transition: all 0.3s ease;
  width: 100%;
  height: 100%;
  padding: 8px;
  box-sizing: border-box;
}
.left-content-hide {
  width: 0;
  transform: scale(0, 1);
  opacity: 0;
}
.left-btn {
  position: absolute;
  right: -8px;
  top: calc(50% - 50px);
  width: 8px;
  height: 100px;
  border-radius: 0 70% 70% 0;
  //background: rgba(0, 0, 0, 0.2);
  background: @basecolor;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4px;
  color: #fff;
  font-weight: bold;
  opacity: 0.7;
  transition: 0.3s;
}
.left-btn:hover {
  opacity: 1;
}
</style>